import React from 'react';
import { connect } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import LeftMenu from '../AppLayout/leftMenu'
import Redirections from './redirections'

const useStyles = makeStyles(theme => ({
  cardGrid: {
    marginTop: '5px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(8),
  },
}));

function ManageRedirections(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        <Container className={classes.cardGrid} maxWidth="md">
          <Grid item style={{ maxWidth: '14%', flexBasis: '14%' }}>
            <LeftMenu history={props.history} />
          </Grid>
        </Container>
      </main>
      <div>
        <Redirections match={props.match} history={props.history}/>
      </div>
    </React.Fragment>
  );
}
const mapStateToProps = state => {
  return {}
}

export default connect(
  mapStateToProps, {}
)(ManageRedirections);